export default "/imgs/bnr-4.png"